<template>
	<div class="head_wrap">
		<div class="head_box">
			<div class="head_con flex1">
				<img class="hc_left" v-show="jcinfo.logo" @click="goHome" :src="staticImg+jcinfo.logo" />
				<div class="hc_right flex3">
					<div class="hr_item" v-for="(item, index) in headList" :key="item.title" @click.stop="navClick(index, item)"
						:class="headAct == index ? 'act_sty2' : ''">
						<span class="nv_tit">{{ item.title }}</span>
						<div class="drop_wrap" v-if="index > 0">
							<div class="drop_box flex2">
								<div class="drop_item" v-for="(item2, index2) in item.zicate" :key="index2"
									@click.stop="navClick2(index,item,item2)" @mouseenter.stop="yiRu(index,index2)"
									@mouseleave.stop="yiChu(index,index2)">
									<img v-if="index == 2" :src="
                                            item2.sel == 1
                                                ? staticImg + item2.images2[0]
                                                : staticImg + item2.images2[1]
                                        " />
									<img v-else :src="staticImg + item2.images" />
									<span v-if="index != 1 && index != 2">{{
                                        item2.title
                                    }}</span>
									<div class="zhezhao animate__animated" :class="item2.sel==2?'animate__fadeOut2':'animate__fadeIn2'"
										v-if="index != 1&& index != 2"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search_btn flex2">
				<img @click="handleSearch" src="@/images/header/search1.png" />
                <!-- <span @click="languageChange">EN</span> -->
			</div>
			<el-collapse-transition>
				<div class="se_box" v-show="seshow">
					<div class="se_con flex3">
						<input type="text" v-model="newsKey" placeholder="请输入关键字" class="ant_input" />
						<button @click="toSearch">
							<img src="@/images/header/search2.png" />
						</button>
					</div>
				</div>
			</el-collapse-transition>
		</div>

		<el-dialog :visible.sync="ageshow" width="50%">
			<div class="top_box">
				<div class="logo">
					<img src="../../images/ag4.png" />
				</div>
				<div class="welcome">
					<img class="welcome" src="../../images/ag1.png" />
				</div>
				<p class="tip_text1">在浏览产品之前，我们需要确认您是否已满18岁：</p>
				<div class="button_box">
					<img class="button_left" src="../../images/ag2.png" @click="matchAge(1)">
					<img class="button_right" src="../../images/ag3.png" @click="matchAge(2)">
				</div>
			</div>
			<div class="bottom_box">温馨提示：未成年人禁止饮酒</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			fw1: false,
			fw2: false,
			seshow: false,
			sortArr: [],
			staticImg: this.$staticImg,
			hvIndex: "",
			jumpCurt: '',
			jump1: {},
			jump2: {},
			ageshow: false,
			newsKey: '',
			jcinfo: {},
		};
	},
	computed: {
		...mapState(["language","headList", "headAct", "useAge"]),
	},
	created() {
		this.basicInfo();
	},
	methods: {
		async basicInfo() {
			const res = await this.$api.basicInfo();
			if (res.code == 1) {
				this.jcinfo = res.data;
			}
		},
        languageChange(){
            this.$store.state.language = 2;
            this.$router.push("/en/home");
            this.$store.state.curtAct = null;
            this.$store.state.curtAct2 = null;
            this.$store.state.headAct = 0;
            this.$store.state.enAct1 = 0;
            localStorage.setItem('yuyan', 2);
        },
		navClick(index, item) {
			this.jump1 = item;
			this.jumpCurt = 1;
			if (item.title == '产品中心') {
				//1不知道多大，2已满18多，3小于18岁
				if (this.useAge == 1) {
					this.ageshow = true;
				}
				if (this.useAge == 2) {
					this.$router.push(item.name);
				}
				if (this.useAge == 3) {
					this.$router.push('/about');
				}
			} else {
				this.$router.push(item.name);
			}
		},
		navClick2(index, item, item2) {
			this.jump2 = item2;
			this.jumpCurt = 2;
			if (item.title == '产品中心') {
				if (this.useAge == 1) {
					this.ageshow = true;
				}
				if (this.useAge == 2) {
					if (item2.title == "最新资讯" || item2.title == "公告公示") {
						this.$router.push({
							path: item2.name,
							query: {
								id: item2.id,
								name: item2.title,
							},
						});
					} else {
						this.$router.push(item2.name);
					}
				}
				if (this.useAge == 3) {
					this.$router.push('/about');
				}
			} else {
				if (item2.title == "最新资讯" || item2.title == "公告公示") {
					this.$router.push({
						path: item2.name,
						query: {
							id: item2.id,
							name: item2.title,
						},
					});
				} else {
					this.$router.push(item2.name);
				}
			}
		},
		matchAge(a) {
			//1不知道多大，2已满18多，3小于18岁
			if (a == 1) {
				this.$store.state.useAge = 2;
				if (this.jumpCurt == 1) { //点击产品中心
					this.$router.push(this.jump1.name);
				}
				if (this.jumpCurt == 2) {//点击产品中心下的产品系列
					if (this.jump2.title == "最新资讯" || this.jump2.title == "公告公示") {
						this.$router.push({
							path: this.jump2.name,
							query: {
								id: this.jump2.id,
								name: this.jump2.title,
							},
						});
					} else {
						this.$router.push(this.jump2.name);
					}
				}
			}
			if (a == 2) {
				this.$store.state.useAge = 3;
				this.$router.push('/about');
			}
			this.ageshow = false;
		},
		yiRu(index, index2) {
			this.headList[index].zicate[index2].sel = 2;
		},
		yiChu(index, index2) {
			this.headList[index].zicate[index2].sel = 1;
		},
		handleSearch() {
			this.seshow = !this.seshow;
		},
		toSearch() {
			if (!this.newsKey.trim()) {
				this.$message({
					message: '请输入搜索内容',
					type: 'error',
					offset: 100,
					duration: 3000
				});
			} else {
				this.$router.push("/newssearch?newsKey=" + this.newsKey);
				this.seshow = false;
			}
		},
		goHome() {
			this.$router.push('/');
		}
	},
};
</script>
<style lang="scss">
.act_sty2 {
	background-color: #d43235 !important;
	border-bottom: 4px solid #d43235 !important;
	.nv_tit {
		color: #fff !important;
		font-weight: bold;
	}
}
.head_wrap {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 3000;
	height: 76px;
	background-color: #fff;
	box-shadow: 0 6px 12px 0 hsla(0, 0%, 40%, 0.1);

	.el-dialog__header {
		display: none;
	}

	.el-dialog__body {
		padding: 0;
		background-image: url("../../images/ag5.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		.top_box {
			padding-top: 60px;
			.logo {
				img {
					width: 240px;
				}
			}
			.welcome {
				margin-top: 10px;
				img {
					width: 150px;
				}
			}
			.tip_text1 {
				margin-top: 60px;
				font-size: 24px;
				color: #000;
                font-family: 'SourceHanSerif';
			}
			.button_box {
				display: flex;
				justify-content: center;
				margin-top: 40px;
				img {
					width: 170px;
					cursor: pointer;
				}
				.button_right {
					margin-left: 100px;
				}
			}
		}

		.bottom_box {
			margin-top: 100px;
			padding-bottom: 60px;
            font-family: 'SourceHanSerif';
			.tip {
				font-size: 18px;
				color: #000;
			}
		}
	}
	.head_box {
		width: 100%;
		position: relative;
		cursor: pointer;
		.search_btn {
			position: absolute;
			right: 30px;
			height: 76px;
			top: 0;
			background-color: #fff;
			img {
				width: 25px;
                margin-top: 3px;
			}
            span{
                margin-left: 15px;
                font-size: 17px;
            }
		}
		.se_box {
			position: absolute;
			right: 15px;
			top: 76px;
			padding: 10px 0;
			width: 570px;
			.se_con {
				background-color: #fff;
				font-size: 0;
				border-radius: 5px;
				overflow: hidden;
				box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
				input {
					background-color: #fff;
					padding: 0 15px;
					color: #333;
					font-size: 14px;
					width: 480px;
					height: 50px;
					vertical-align: middle;
					outline: none;
					border: none;
				}
				button {
					outline: none;
					border: none;
					background-color: #d43235;
					background-image: url("/images/header/search2.png");
					background-repeat: no-repeat;
					height: 50px;
					width: 90px;
					vertical-align: middle;
					cursor: pointer;
				}
			}
		}
		.head_con {
			margin: 0 auto;
			max-width: 1300px;
			height: 76px;
			.hc_left {
				width: 210px;
				height: auto;
			}
			.hc_right {
				.hr_item {
					box-sizing: border-box;
					border-bottom: 4px solid #fff;
					height: 76px;
					&:nth-child(4) {
						.drop_wrap {
							.drop_box {
								padding-left: 370px;
							}
						}
					}
					&:nth-child(5) {
						.drop_wrap {
							.drop_box {
								padding-left: 640px;
							}
						}
					}
					&:nth-child(6) {
						.drop_wrap {
							.drop_box {
								padding-left: 880px;
							}
						}
					}
					&:nth-child(7) {
						.drop_wrap {
							.drop_box {
								padding-left: 1170px;
							}
						}
					}
					&:hover {
						border-bottom: 4px solid #c4a156;
						.drop_wrap {
							display: block;
						}
						.nv_tit {
							color: #c4a156;
						}
					}
					.nv_tit {
						display: block;
						padding: 0 35px;
						color: #333;
						font-size: 17px;
						height: 76px;
						line-height: 76px;
					}
					.drop_wrap {
						position: absolute;
						top: 76px;
						left: 0;
						right: 0;
						z-index: 11;
						background-color: #f5f5f5;
						padding: 30px 30px 30px 60px;
						display: none;
						.drop_box {
							.drop_item {
								position: relative;
								width: 180px;
								height: 130px;
								border-radius: 5px;
								margin-right: 30px;
								overflow: hidden;
								&:hover {
									span {
										border-bottom: 2px solid #fff;
									}
								}
								img {
									width: 180px;
									height: 130px;
									border-radius: 5px;
								}
								span {
									position: absolute;
									left: 50px;
									top: 50px;
									z-index: 12;
									color: #fff;
									font-size: 20px;
									line-height: 0.9;
								}
								.zhezhao {
									position: absolute;
									left: 0;
									top: 0;
									right: 0;
									bottom: 0;
									z-index: 10;
									background-color: rgba(0, 0, 0, 0.5);
									animation-duration: 0.6s;
								}
							}
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1700px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1200px;
				.hc_right {
					padding-right: 60px;
					.hr_item {
						&:nth-child(3) {
							.drop_wrap {
								.drop_box {
									padding-left: 70px;
								}
							}
						}
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 290px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 510px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 740px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 980px;
								}
							}
						}
						.nv_tit {
							padding: 0 24px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1500px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1200px;
				.hc_right {
					padding-right: 100px;
					.hr_item {
						&:nth-child(3) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
								}
							}
						}
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 200px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 430px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 680px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 880px;
								}
							}
						}
						.nv_tit {
							padding: 0 24px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1400px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1200px;
				.hc_right {
					padding-right: 150px;
					.hr_item {
						.drop_wrap {
							padding: 30px 0 30px 30px;
						}
						&:nth-child(3) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
								}
							}
						}
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 160px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 370px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 600px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 800px;
								}
							}
						}
						.nv_tit {
							padding: 0 20px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1300px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1200px;
				.hc_right {
					padding-right: 150px;
					.drop_wrap {
						padding: 30px 0 30px 30px;
					}
					.hr_item {
						&:nth-child(3) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
								}
							}
						}
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 160px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 370px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 600px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 800px;
								}
							}
						}
						.nv_tit {
							padding: 0 20px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1250px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1200px;
				padding-left: 30px;
				padding-right: 80px;
				.hc_left {
					width: 150px;
				}
				.hc_right {
					.hr_item {
						.drop_wrap {
							padding: 30px 0 30px 30px;
						}
                        &:nth-child(3) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
									.drop_item {
										position: relative;
										width: 120px;
										height: 86px;
										border-radius: 5px;
										margin-right: 30px;
										overflow: hidden;
										&:hover {
											span {
												border-bottom: 2px solid #fff;
											}
										}
										img {
											width: 120px;
											height: 86px;
											border-radius: 5px;
										}
										span {
											position: absolute;
											left: 50px;
											top: 50px;
											z-index: 12;
											color: #fff;
											font-size: 20px;
											line-height: 0.9;
										}
									}
								}
							}
						}
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 10px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 240px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 450px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 630px;
								}
							}
						}
						.nv_tit {
							padding: 0 20px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1150px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 1000px;
				.hc_left {
					width: 120px;
				}
				.hc_right {
					.hr_item {
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 100px;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 240px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 430px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 570px;
								}
							}
						}
						.nv_tit {
							padding: 0 10px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1050px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 900px;
				.hc_left {
					width: 120px;
				}
				.hc_right {
					.hr_item {
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 140px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 320px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 470px;
								}
							}
						}
						.nv_tit {
							padding: 0 10px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 950px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 900px;
				.hc_left {
					width: 120px;
				}
				.hc_right {
                    padding-right: 100px;
					.hr_item {
						&:nth-child(4) {
							.drop_wrap {
								.drop_box {
									padding-left: 0;
								}
							}
						}
						&:nth-child(5) {
							.drop_wrap {
								.drop_box {
									padding-left: 120px;
								}
							}
						}
						&:nth-child(6) {
							.drop_wrap {
								.drop_box {
									padding-left: 280px;
								}
							}
						}
						&:nth-child(7) {
							.drop_wrap {
								.drop_box {
									padding-left: 420px;
								}
							}
						}
						.nv_tit {
							padding: 0 10px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 880px) {
	.head_wrap {
		.head_box {
			.head_con {
				max-width: 750px;
				.hc_right {
					display: none;
				}
			}
		}
	}
}
</style>